<template>
  <div class="form-signin">
    <form v-on:submit="auth" method="post">
      <div class="row">
        <div class="col-md-12 text-center">
          <img
            id="logo"
            src="https://sistemclinupload.s3.amazonaws.com/logo.png"
            alt="SISTEMA CLIN"
          />
        </div>
        <div class="col-md-12 mb-0 pb-0">
          <v-text-field
            label="E-mail"
            outlined
            dense
            autocomplete="off"
            type="email"
            :disabled="loading"
            :loading="loading"
            v-model="email"
          />
        </div>
        <div class="col-md-12 mb-0 pb-0 mt-0 pt-0">
          <v-text-field
            label="Senha"
            outlined
            dense
            autocomplete="off"
            type="password"
            :disabled="loading"
            :loading="loading"
            v-model="password"
          />
        </div>
        <div class="col-md-12 mb-0 pb-0 mt-0 pt-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-12 mt-0 pt-0">
          <v-btn
            :disabled="loading"
            type="submit"
            class="btn-login btn-block"
            >{{ loading ? "Carregando" : "Entrar" }}</v-btn
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ErrorsMessages from "./components/ErrorsMessages";
import routes from "../routes";
import api from "../services/api";

export default {
  name: "FormSignIn",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      email: "",
      password: "",
      loading: false,
    };
  },
  methods: {
    async auth(event) {
      event.preventDefault();

      this.loading = true;

      try {
        const { email, password } = this;

        const response = await api.post("/admin/auth", {
          email,
          password,
        });

        const { error, errors, admin, permissions } = response.data;

        if (!error) {
          this.errors = [];

          sessionStorage.setItem("admin", JSON.stringify(admin));
          sessionStorage.setItem("permissions", JSON.stringify(permissions));

          routes.push({ name: "clients" });
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.btn-login {
  background-color: #4e9130 !important;
  color: #fff !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}

.form-signin {
  margin: auto;
  margin-top: 100px;
  max-width: 420px;
  padding: 25px;
  box-shadow: 2px 5px 5px 5px #f1f1f1f1;
}
</style>